import DashboardIncidentSeverityBreakdownCard from './DashboardIncidentSeverityBreakdownCard';

export default DashboardIncidentSeverityBreakdownCard;
